/* ─── CATEGORY BADGES ─── */
export const CATEGORY_COLORS = {
  Liposomal:            { bg: "#fdf2f8", text: "#be185d", border: "#f9a8d4" },
  Antimetabolite:       { bg: "#eff6ff", text: "#1d4ed8", border: "#93c5fd" },
  Platinum:             { bg: "#f0fdf4", text: "#15803d", border: "#6ee7b7" },
  Alkylating:           { bg: "#f5f3ff", text: "#6d28d9", border: "#c4b5fd" },
  Taxane:               { bg: "#f0fdfa", text: "#0f766e", border: "#5eead4" },
  Antibiotic:           { bg: "#fff7ed", text: "#c2410c", border: "#fdba74" },
  Topoisomerase:        { bg: "#f0fdf4", text: "#166534", border: "#86efac" },
  Hormonal:             { bg: "#fef2f2", text: "#b91c1c", border: "#fca5a5" },
  Antifolate:           { bg: "#ecfeff", text: "#0e7490", border: "#a5f3fc" },
  "Proteasome Inhibitor": { bg: "#f0f9ff", text: "#0369a1", border: "#38bdf8" },
  "Vinca Alkaloid":     { bg: "#fdf2f8", text: "#9d174d", border: "#f472b6" },
  Uroprotective:        { bg: "#f0fdf4", text: "#14532d", border: "#4ade80" },
  Tablet:               { bg: "#eff6ff", text: "#1d4ed8", border: "#93c5fd" },
  Capsule:              { bg: "#f5f3ff", text: "#6d28d9", border: "#c4b5fd" },
  Injection:            { bg: "#f0f9ff", text: "#0369a1", border: "#7dd3fc" },
  "Oral Support":       { bg: "#fff7ed", text: "#c2410c", border: "#fdba74" },
};
